import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { deepOrange } from '@material-ui/core/colors';
import moment from 'moment-timezone';
import { Comment } from '../../types/comment';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: '36ch',
      backgroundColor: theme.palette.background.paper,
    },
    avatar: {
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
    },
    comment: {
      backgroundColor: 'red',
    },
  })
);

type CommentListProps = {
  comments: Comment[];
};

export const CommentList = ({ comments = [] }: CommentListProps) => {
  const classes = useStyles();

  if (!comments.length) return null;

  return (
    <List className={classes.root}>
      {comments.map((comment) => (
        <ListItem alignItems="flex-start" key={comment.creationDateTime}>
          <ListItemAvatar>
            <Avatar alt="Remy Sharp" className={classes.avatar}>
              {' '}
              {comment?.authorFirstName?.charAt(0)}{' '}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <div>
                {`${comment.authorFirstName} ${comment.authorLastName}`}
                <Typography component="div" variant="caption" color="textPrimary">
                  {moment(comment.creationDateTime).format('DD/MM/YYYY HH:mm')}
                </Typography>
              </div>
            }
            secondary={comment.commentaire}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default CommentList;
